import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

export const TopicsDiscoverAllTopicsModalHeader = () => {
    const t = useTranslation();

    return (
        <Flex
            flexDirection="column"
            gap="8px"
            padding="20px 0 20px 24px"
        >
            <Text
                as="h5"
                fontVariant="h5"
                color={colorsPalettes.carbon[500]}
            >
                {t("demand.analysis.home.discover.modal.header.title")}
            </Text>
        </Flex>
    );
};
